var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.selectedOption)?_c('flag',{staticClass:"me-4 ms-4 h-full",attrs:{"country":_vm.selectedOption.value}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }